module.exports = __webpack_public_path__ + "img/20_teq_y_soda.de127860.jpg";